import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take, withLatestFrom, switchMap } from 'rxjs/operators';
import * as fromAuth from 'src/app/modules/authentication/store/auth';
import * as fromRouting from '../../core/store/routing';
import { Location } from '@angular/common';
import { DEFAULT_APP_CULTURE_CODE } from '../../core/languages/language.model';

@Injectable({
  providedIn: 'root'
})
export class ValidTokenRouteGuardService implements CanActivate {
  destroy$ = new Subject<void>();

  constructor(
    private store: Store<fromAuth.State>,
    private http: HttpClient,
    private location: Location
  ) {}

  canActivate(): boolean {
    let validTokenExists = false;

    this.store
      .select(fromAuth.selectUserContext)
      .pipe(withLatestFrom(this.store.select(fromAuth.selectToken), this.store.select(fromRouting.selectQueryParams)), take(1))
      .subscribe(([ctx, token, params]) => {
        if (!!ctx) {
          const expDate = ctx.expiration * 1000;
          validTokenExists = expDate > Date.now() ? true : false;
        }
      });

    if (!validTokenExists) {
      if (location.pathname === '/external-link') {
        return true;
      }
      this.store.dispatch(fromAuth.logout());
      return false;
    }

    return true;
  }
}
